import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual-user',
  templateUrl: './manual-user.component.html',
  styleUrls: ['./manual-user.component.scss']
})
export class ManualUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
